// Single source of truth for which video files may be uploaded across the app.
// Today the app only accepts MP4. Expanding later (e.g. adding MOV) should be a
// one-line change here — every video upload entry point imports from this file.

// Allowed file extensions (lower-case, with leading dot).
export const ALLOWED_VIDEO_EXTENSIONS = ['.mp4'];

// Allowed MIME types (lower-case).
export const ALLOWED_VIDEO_MIME_TYPES = ['video/mp4'];

// Human-readable label used in hints/messages.
export const ALLOWED_VIDEO_FORMAT_LABEL = 'MP4';

// Format expected by Uppy's `restrictions.allowedFileTypes`
// (accepts MIME globs and/or extensions).
export const UPPY_ALLOWED_VIDEO_FILE_TYPES = ['video/mp4', '.mp4'];

// Value for a native <input type="file"> `accept` attribute.
export const VIDEO_UPLOAD_ACCEPT = 'video/mp4,.mp4';

// Shown to the user whenever a non-MP4 video is chosen or dropped.
export const MP4_ONLY_ERROR_MESSAGE =
  'Only MP4 files are supported. Please convert your video to MP4 and try again.';

// Case-insensitive validation for a single File/Blob-like object.
// A file is allowed when it has an allowed extension AND either reports an
// allowed MIME type or reports no MIME at all (some browsers/files leave `type`
// empty for otherwise-valid MP4s — fall back to the extension in that case).
export function isAllowedVideoFile(file) {
  if (!file) return false;
  const name = String(file.name || '').toLowerCase();
  const type = String(file.type || '').toLowerCase();
  const hasAllowedExtension = ALLOWED_VIDEO_EXTENSIONS.some((ext) => name.endsWith(ext));
  if (!hasAllowedExtension) return false;
  // Empty MIME → trust the extension.
  if (!type) return true;
  return ALLOWED_VIDEO_MIME_TYPES.includes(type);
}

// True when at least one file in the given list is not an allowed video upload.
// Accepts an Array, FileList, or anything iterable via Array.from.
export function hasDisallowedVideoFile(files) {
  return Array.from(files || []).some((file) => !isAllowedVideoFile(file));
}
